import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import MatchEventCardAvantgardeImpl from './match-event-card-avantgarde.js';
import EventCardsTypes from 'modules/event-cards/types.js';

/**
 * Avantgarde design style match event card. Leads with a category badge and replaces the single
 * market of the classic card with a swipeable slider over the event market lines.
 *
 * @function MatchEventCardAvantgarde
 * @name view
 *
 * @memberof Mojito.Modules.EventCards.Match.Avantgarde
 */

/**
 * Avantgarde match event card prop types.
 *
 * @property {string} eventId - Id of event to show.
 * @property {string} [marketId] - Promoted market id shown as the first slider slide when not a game-line card.
 * @property {string} [marketName] - Market name when the card is not a game-line card.
 * @property {object} [gameLine] - Game line option for US sports cards.
 * @property {object} [marketLines] - Market lines keyed by line type.
 * @property {string} [imgUrl] - Optional card background image.
 * @property {Mojito.Modules.EventCards.types.COLOR_MODES} [colorMode] - Card presentation mode.
 * @property {boolean} [shouldRequestData = true] - Whether the card requests event and market data.
 * @property {boolean} [showSkeleton = true] - Whether the skeleton shows while data loads.
 * @property {boolean} [reportLoadingStatus = false] - Whether the card reports render readiness for page metrics.
 * @property {object | Function} [elementRef] - Ref to the rendered element.
 *
 * @memberof Mojito.Modules.EventCards.Match.Avantgarde.view
 */
const propTypes = {
    eventId: PropTypes.string.isRequired,
    marketId: PropTypes.string,
    marketName: PropTypes.string,
    gameLine: PropTypes.object,
    marketLines: PropTypes.object,
    imgUrl: PropTypes.string,
    colorMode: PropTypes.oneOf(Object.values(EventCardsTypes.COLOR_MODES)),
    shouldRequestData: PropTypes.bool,
    showSkeleton: PropTypes.bool,
    reportLoadingStatus: PropTypes.bool,
    elementRef: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

const defaultProps = {
    shouldRequestData: true,
    showSkeleton: true,
    reportLoadingStatus: false,
};

export default MojitoCore.Presentation.UIView(
    'MatchEventCardAvantgarde',
    MatchEventCardAvantgardeImpl,
    propTypes,
    defaultProps
);
